'use strict';


function isMobile(param) {
  return window.innerWidth <= 850;
}

exports.isMobile = isMobile;
/* No side effect */
